import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  leftWrapper: {
    color: "white",
    background: theme.colors.midnightBlue[0],
  },
  iconWrapper: {
    background: "transparent",
    width: rem(46),
    height: rem(46),
    margin: rem(2),
    borderRadius: rem(2),
  },
  buttonLink: {
    textDecoration: "none",
    width: "100%",
    "&:active": {
      color: "inherit!important",
    },
  },
  link: {
    textDecoration: "none",
    color: theme.colors.dusk[0],
    "&:active": {
      color: "inherit!important",
    },
  },
}));
